import Api from '@/services/Api'

// load, create, and delete class logins for the authenticated user

export default {
  get(accessCode) {
    return Api().get(`share/${accessCode}`);
  },
  post(data) {
    return Api().post('share', {payload: data});
  },
  put(accessCode, data) {
    return Api().put(`share/${accessCode}`, {payload: data});
  },
  delete(accessCode) {
    return Api().delete(`share/${accessCode}`);
  }
}